import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "more",
  "use": "more-usage",
  "viewBox": "0 0 30 33",
  "content": "<symbol viewBox=\"0 0 30 33\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"more\">\n<path d=\"M21.498 16.2617L0.375 8.50293V0.333984L29.9062 13.0488V19.6455L0.375 32.3604V24.1914L21.498 16.2617Z\" fill=\"#848688\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol